import { Reveal } from "./Reveal";

export const PageHero = ({ overline, title, sub, children, tone = "light" }) => (
  <section
    className={`relative overflow-hidden px-6 pb-20 pt-[60px] lg:px-10 lg:pb-28 lg:pt-[83px] ${
      tone === "deep" ? "bg-ostelo-deep" : "bg-white"
    }`}
    data-testid="page-hero"
  >
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className={`text-xs font-bold uppercase tracking-[0.2em] ${tone === "deep" ? "text-ostelo-orange" : "text-ostelo-blue"}`}>
          {overline}
        </p>
        <h1 className={`mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl ${tone === "deep" ? "text-white" : "text-ostelo-deep"}`}>
          {title}
        </h1>
        {sub && (
          <p className={`mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${tone === "deep" ? "text-white/65" : "text-ostelo-ink/65"}`}>
            {sub}
          </p>
        )}
      </Reveal>
      {children && <div className="mt-12">{children}</div>}
    </div>
  </section>
);
